/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { AddressValidationRequest } from "@rc/App/Services/checkoutServices";
import { Draft } from "immer";

type DropShipAddressesState = Readonly<{
    isLoading: boolean;
    data?: ShipToModel[];
    useNewAddress: boolean;
    requestAddress?: AddressValidationRequest;
    suggestedAddresses?: AddressValidationRequest[];
    displaySuggestedAddressModal: boolean;
    orderConfirmationEmail: string;
}>;

const initialProductInfoStae: DropShipAddressesState = {
    isLoading: false,
    data: undefined,
    useNewAddress: false,
    displaySuggestedAddressModal: false,
    suggestedAddresses: [],
    requestAddress: undefined,
    orderConfirmationEmail: "",
};

const reducer = {
    "xCheckout/BeginLoading": (draft: Draft<DropShipAddressesState>) => {
        draft.isLoading = true;
    },
    "xCheckout/CompletedLoading": (draft: Draft<DropShipAddressesState>, actions: { data?: ShipToModel[] }) => {
        draft.isLoading = false;
        if (actions?.data?.length) {
            draft.data = actions.data;
        }
    },
    "xCheckout/ToggleUserNewAddress": (draft: Draft<DropShipAddressesState>, action: { useNewAddress: boolean }) => {
        draft.useNewAddress = action.useNewAddress;
    },
    "xCheckout/SetAddressSuggesionModalData": (
        draft: Draft<DropShipAddressesState>,
        action: { suggestedAddresses: AddressValidationRequest[]; requestAddress: AddressValidationRequest },
    ) => {
        draft.displaySuggestedAddressModal = true;
        draft.suggestedAddresses = action.suggestedAddresses;
        draft.requestAddress = action.requestAddress;
    },
    "xCheckout/HideAddressSuggestionModal": (draft: Draft<DropShipAddressesState>) => {
        draft.displaySuggestedAddressModal = false;
    },
    "xCheckout/HandleOrderConfirmationEmailChange": (
        draft: Draft<DropShipAddressesState>,
        action: { email: string },
    ) => {
        draft.orderConfirmationEmail = action.email;
    },
};

const xDropShipAddresses = createTypedReducerWithImmer(initialProductInfoStae, reducer);

(reducers as any).xDropShipAddresses = xDropShipAddresses;

export type xDropShipAddressesState = {
    xDropShipAddresses: DropShipAddressesState;
};

type xDropShipAddressesReducers = {
    isLoading: typeof xDropShipAddresses;
    data: typeof xDropShipAddresses;
};

export type xProductInfoActions =
    | Parameters<xDropShipAddressesReducers[keyof xDropShipAddressesReducers]>[1]
    | AnyAction;
